import { PROTOCOL_DEFINITION_KIND } from "@repo/api";
export const PINNED_PROTOCOL_KINDS = [PROTOCOL_DEFINITION_KIND];
